<div class="ag-details-row ag-details-row-fixed-height">
  <div class="detail-header">
    <span class="detail-description">{{params.data.description}}</span>
  </div>
  <div ref="eDetailGrid" class="detail-grid"></div>
</div> 